import moment from 'moment'

const formatDateToString = (date: Date, format = 'DD-MM-YYYY') => {
  return moment(date).format(format)
}

const getDayOfWeekText = (date: Date) => {
  return moment(date).format('dddd')
}

const getMonthShortText = (date: Date) => {
  return moment(date).format('MMM').slice(0, -1)
}

const addToDate = (
  date: Date,
  { value, type }: { value: number; type: 'days' | 'months' }
) => {
  return moment(date).add(value, type).toDate()
}

const getDaysDiff = (date1: Date, date2: Date) => {
  return moment(date2).diff(date1, 'days')
}

const getMonthsDiff = ({
  date1,
  date2,
  getDecimals = false
}: {
  date1: Date
  date2: Date
  getDecimals?: boolean
}) => {
  return moment(date2).diff(date1, 'months', getDecimals)
}

const getDateList = (from: Date, to: Date) => {
  const dateList = [from]

  const currentDate = moment(from)

  while (currentDate.isBefore(to)) {
    currentDate.add(1, 'day')
    dateList.push(currentDate.clone().toDate())
  }

  return dateList
}

const isValid = (string: string) => {
  return !isNaN(new Date(string) as any)
}

const dayOfWeek = (date: Date) => {
  return moment(date).weekday()
}

const isWeekend = (date: Date) => {
  const isoDayOfWeek = moment(date).isoWeekday()
  return isoDayOfWeek === 5 || isoDayOfWeek === 6
}

const toDayString = (date: Date) => {
  return moment(date).format('DD')
}

const toMonthStr = (date: Date) => {
  return moment(date).format('MMMM')
}

export const dateUtils = {
  formatDateToString,
  addToDate,
  getDaysDiff,
  getMonthsDiff,
  getDateList,
  getDayOfWeekText,
  getMonthShortText,
  isValid,
  dayOfWeek,
  isWeekend,
  toDayString,
  toMonthStr
}
